"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng_from_import = require("angular");
var ng_from_global = angular;
exports.ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-router/lib/angular.js
// module id = 111
// module chunks = 1